const apiURLv2 = '/rest/V2/sdg-api';
const searchCriteria =
  '?searchCriteria[filter_groups][0][filters][0][field]=country_permission&searchCriteria[filter_groups][0][filters][0][value]=CA,US&searchCriteria[filter_groups][0][filters][1][field]=country_permission&searchCriteria[filter_groups][0][filters][1][value]=US&searchCriteria[filter_groups][0][filters][2][field]=country_permission&searchCriteria[filter_groups][0][filters][2][value]=US,CA&searchCriteria[pageSize]=100';

export const config = {
  endpoints: {
    fetchBrands: '/brands/index/getbrands',
    fetchLaunches: '/launches_frontend/campaign/get',
  },
};
